export default __webpack_public_path__ + "static/media/AFM_rond_risicoscore6.a380ffd5.jpg";